import { generateHashData } from "../utils/func";
import { AxiosInstance } from "./api";

AxiosInstance.interceptors.request.use((config) => {
  const id = "wiezon";

  const reqDate = new Date()
    .toISOString()
    .replace(/[-T:.Z]/g, "")
    .slice(0, 14); // YYYYMMDDHHmmss

  const hashData = generateHashData(id, reqDate);

  config.headers.id = id;
  config.headers.reqDate = reqDate;
  config.headers.hashData = hashData;

  return config;
});
